import { TreeNode } from 'primeng/api';
import { ChopHierarchyNode } from '@entity/chop';
import { Language, getLocalized } from '@entity/language';

export function buildChopHierarchyTree(nodes: ChopHierarchyNode[], language: Language): TreeNode[] {
  const treeNodes = new Map<string, TreeNode>();

  for (const node of nodes) {
    const key = `${node.type}_${node.id}`;
    treeNodes.set(key, {
      key,
      label: `${node.code} ${getLocalized(node.bezeichnung, language)}`,
      data: node,
      selectable: node.type === 'profil',
      children: [],
      expanded: node.type === 'alterskategorie',
    });
  }

  const roots: TreeNode[] = [];

  for (const node of nodes) {
    const key = `${node.type}_${node.id}`;
    const treeNode = treeNodes.get(key);
    if (!treeNode) {
      continue;
    }

    let parentKey: string | undefined;
    if (node.type === 'leistungsgruppe' && node.parentId != null) {
      parentKey = `alterskategorie_${node.parentId}`;
    } else if (node.type === 'profil' && node.parentId != null) {
      parentKey = `leistungsgruppe_${node.parentId}`;
    }

    const parentTreeNode = parentKey ? treeNodes.get(parentKey) : undefined;
    if (parentTreeNode) {
      parentTreeNode.children!.push(treeNode);
    } else {
      roots.push(treeNode);
    }
  }

  return roots;
}
